import type React from 'react'


import { tw } from 'tagged-classnames-free';
interface IGradientBorderCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  innerClassName?: string
}

export const GradientBorderCard: React.FC<IGradientBorderCardProps> = ({
  children,
  className,
  innerClassName,
  ...rest
}) => {
  return (
    <div
      className={tw`group rounded-xl bg-transparent p-px transition-all duration-300 hover:bg-[linear-gradient(90deg,#FF3466,#FF4BF3,#8635FF)] ${className}`}
      {...rest}
    >
      <div
        className={tw`border-f-border flex h-full flex-col items-start gap-3 rounded-xl border bg-[#1A1A24] p-8 group-hover:border-transparent ${innerClassName}`}
      >
        {children}
      </div>
    </div>
  )
}
